import { format, isPast } from "date-fns";
import { it } from "date-fns/locale";

function formatDate(source: string | null) {
  if (source) {
    const date = new Date(source.slice(0, 10));
    return format(date, "dd/MM/yyyy");
  }

  return null;
}

function parseDate(source: string | null, days: number = 0) {
  if (!source) {
    return null;
  }

  const date = new Date(source.slice(0, 10));
  date.setDate(date.getDate() + (days || 0));

  if (!date || isNaN(date.getTime())) {
    return null;
  }

  return describeDate(date);
}

function describeDate(date: Date) {
  const options = {
    locale: it,
  };

  return {
    full: format(date, "dd/MM/yyyy", options),
    fullDots: format(date, "dd.MM.yyyy", options),
    short: format(date, "d/M", options),
    shortDots: format(date, "d.M", options),
    long: format(date, "d MMMM yyyy", options),
    isPast: isPast(date),
  };
}

export {
  parseDate,
  formatDate,
  describeDate,
};
